<template>
  <b-container>
    <FanEditProfileTabs />

    <b-row>
      <b-col class="hero">
        <img class="hero" :src="heroImage">
        <h1>{{ displayName }}</h1>

        <div class="avatar">
          <img class="avatar" :src="avatarImage">
          <img class="avatar avatar-change-btn" src="/static/icons/change-picture.png" @click="selectAvatar">
          <input type="file" id="avatarFileInput" ref="avatarFileInput" @change="updateAvatar" />
        </div>
        <b-button class="btn-secondary" @click="selectHero">change profile image</b-button>
        <input type="file" id="heroFileInput" ref="heroFileInput" @change="updateHero" />
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col class="img-req" cols="12" md="6">
        Avatar image: .png, .jpg / 370 x 370 px minimum
      </b-col>
      <b-col class="img-req text-right" cols="12" md="6">
        Profile image: .png, .jpg / 1140 x 480 px minimum
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col>
        <h3>Personal Information</h3>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" lg="6">
        <b-form-group label="User Handle"
                      description="Your user handle, can't be changed">
          <b-form-input id="username" type="text" readonly :value="'@' + currentUser.username" />
        </b-form-group>
      </b-col>
      <b-col cols="12" lg="6">
        <b-form-group label="E-Mail"
                      label-for="email"
                      description="Your e-mail address (won't be shown publicly, can't be changed)">
          <b-form-input id="email" type="email" readonly :value="currentUser.email" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="6">
        <b-form-group id="genderGroup"
                      label="Gender"
                      label-for="gender"
                      description="Your gender (optional, won't be shown publicly)">
          <b-form-select id="gender" :options="genderOptions" v-model="currentUser.gender" />
        </b-form-group>
      </b-col>
      <b-col cols="12" lg="6">
        <b-form-group id="dobGroup"
                      label="Date of Birth"
                      label-for="dob"
                      description="Your date of birth (optional, won't be shown publicly)">
          <datepicker id="dob"
                      calendar-class="dob"
                      :value="dobDate"
                      initial-view="year"
                      format="MM/dd/yyyy"
                      @selected="updateDate"></datepicker>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Explicit Content"
                      description="If disabled, we'll do our best to keep explicit video content, such as strong language or age inappropriate material, from your view">
          <b-form-checkbox v-model="currentUser.show_explicit">
              Show explicit content
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group id="bioGroup"
                      label="Bio"
                      label-for="bio"
                      description="Tell us something about yourself (optional)">
          <b-form-textarea id="bio" :rows="5" :max-rows="10" required placeholder="Who are you?" v-model="currentUser.bio"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="form-actions">
      <b-col>
        <a class="cancel" href="#" @click="cancel">cancel</a>
        <b-button class="btn-rainbow" @click="save">save information</b-button>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col>
        <h3>Update password</h3>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" lg="6">
        <b-form-group id="pwd1Group"
                      label="New password"
                      label-for="pwd1"
                      description="Type in your new password">
          <b-form-input id="pwd1" v-model="pwd1" type="password" required placeholder="New password" />
        </b-form-group>
      </b-col>
      <b-col cols="12" lg="6">
        <b-form-group id="pwd2Group"
                      label="Repeat new password"
                      label-for="pwd2"
                      :description="pwdMismatchDescription">
          <b-form-input id="pwd2" v-model="pwd2" :state="pwdMismatchState" type="password" required placeholder="Repeat new password" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="form-actions">
      <b-col>
        <a class="cancel" href="#" @click="cancelPassword">cancel</a>
        <b-button class="btn-rainbow" :disabled="pwdMismatchDisabled" @click="updatePassword">update password</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-button class="btn btn-danger btn-secondary mt-4 mt-sm-0" v-b-modal.confirmDeactivate>
          <font-awesome-icon icon="times" />
          &nbsp;
          Close account
        </b-button>
      </b-col>
    </b-row>

    <b-modal id="confirmDeactivate"
             ref="confirmDeactivate"
             title="Close account"
             @ok="deactivateAccount"
             centered>
      <div class="content">
        <p>
          Are you sure you want to close your account?
        </p>
        <p>
          You will lose all access to any purchased songs.
        </p>
        <p v-if="isArtist">
          All your videos and live streams will be removed from Songback.
          Users who purchased your songs will still have access to them.
        </p>
      </div>
    </b-modal>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .hero {
    position: relative;

    img.hero {
      width: 100%;
      min-height: 300px;
      object-fit: cover;
    }

    h1 {
      position: absolute;
      left: 30px;
      bottom: 20px;
      color: $bluish-white;
      text-shadow: 2px 2px 0 #000;
      font-size: 2.5rem;
      margin: 0 0 .5rem 0;
    }

    .avatar {
      position: absolute;
      left: 15px;
      bottom: 45px;

      img.avatar {
        width: 100px;
        height: 100px;
        border-radius: 100%;
      }

      .avatar-change-btn {
        cursor: pointer;
      }

      #avatarFileInput {
        display: none;
      }
    }

    button.btn-secondary {
      right: 20px;
      bottom: 10px;
      position: absolute;
      @include media-breakpoint-down(xs) {
        bottom: auto;
        top: 6px;
      }
    }

    #heroFileInput {
      display: none;
    }
  }

  .img-req {
    font-size: 0.8em;
    color: $steel;
  }

  @include media-breakpoint-down(sm) {
    .img-req {
      text-align: center !important;
    }
  }

  .profile-tabs {
    margin-top: 1em;
    margin-bottom: 1em;

    /deep/ a {
      color: $white;

      &.active {
        color: $white;
        border-bottom: 2px solid $white;
      }

      margin-bottom: -2px;
    }

    box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.5);
    margin-bottom: 2em;
  }

  h3 {
    margin-top: 1em;
  }

  .form-actions {
    text-align: right;
    /deep/ button {
      padding-left: 2em;
      padding-right: 2em;
    }
    a.cancel {
      color: $bluish-white;
      text-decoration: underline;
      margin-right: 2em;
    }
  }
</style>

<script>
import { mapGetters, mapActions } from 'vuex'

import Datepicker from 'vuejs-datepicker'
import FanEditProfileTabs from '@/components/widgets/FanEditProfileTabs'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import { SET_USER_DOB } from '@/store/mutationTypes'

export default {
  name: 'Home',
  components: {
    Datepicker,
    FanEditProfileTabs,
    FontAwesomeIcon
  },
  data () {
    return {
      pwd1: '',
      pwd2: '',
      genderOptions: [
        {value: '', text: 'Unspecified'},
        {value: 'male', text: 'Male'},
        {value: 'female', text: 'Female'}
      ]
    }
  },
  computed: {
    ...mapGetters('profile', ['currentUser', 'avatarImage', 'heroImage', 'displayName', 'dobDate', 'isArtist']),
    pwdMismatchState () {
      return (this.pwd1 === this.pwd2) ? null : 'invalid'
    },
    pwdMismatchDescription () {
      if (!this.pwd2) {
        return 'Repeat your password, to avoid typing mistakes'
      }
      return (this.pwd1 === this.pwd2) ? 'Passwords match' : 'Password mismatch, please check you retyped it correctly'
    },
    pwdMismatchDisabled () {
      return !(this.pwd1 && this.pwd1 === this.pwd2)
    }
  },
  methods: {
    save () {
      this.$store.dispatch('profile/updateCurrentUser').then(() => {
        this.$store.dispatch('flash/showMessage', {message: 'You\'ve updated your profile'})
        this.$router.push({name: 'fan-profile-preview'})
      })
    },
    cancel () {
      this.$store.dispatch('profile/getCurrentUser').then(() => {
        this.$router.push({name: 'fan-profile-preview'})
      })
    },
    selectAvatar () {
      this.$refs.avatarFileInput.click()
    },
    async updateAvatar () {
      let input = this.$refs.avatarFileInput
      if (input.files.length !== 1) {
        return
      }

      this.showModal('Uploading avatar image ...')
      await this.$store.dispatch('profile/setUserAvatar', {file: input.files[0]})
      this.hideModal()
    },
    selectHero () {
      this.$refs.heroFileInput.click()
    },
    async updateHero () {
      let input = this.$refs.heroFileInput
      if (input.files.length !== 1) {
        return
      }

      this.showModal('Uploading profile image ...')
      await this.$store.dispatch('profile/setUserHeroImage', {file: input.files[0]})
      this.hideModal()
    },
    updateDate (date) {
      this.$store.commit('profile/' + SET_USER_DOB, date)
    },
    async updatePassword () {
      if (!this.pwd1 || this.pwd1 !== this.pwd2) return
      try {
        await this.$store.dispatch('auth/changePassword', this.pwd1)
        this.pwd1 = ''
        this.pwd2 = ''
        this.$store.dispatch('flash/showMessage', { message: 'Password changed' })
      } catch (e) {
        this.$store.dispatch('flash/showMessage', { message: e.message, type: 'error' })
      }
    },
    cancelPassword () {
      this.pwd1 = ''
      this.pwd2 = ''
    },
    async deactivateAccount () {
      await this.$store.dispatch('profile/deactivate')
      this.$store.dispatch('flash/showMessage', { message: 'Account closed' })
    },
    ...mapActions('flash', ['showModal', 'hideModal'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/fan/EditProfile.vue